import React, { useEffect, useState, useRef } from 'react';
import FramePlayer from '../utils/FramePlayer';
import anime, { set } from 'animejs';
import HomeButton from '../utils/HomeButton';
import { Navigate, useNavigate } from 'react-router-dom';

const audio = new Audio(process.env.PUBLIC_URL + "/assets/sounds/sardaigne.mp3");
const audioSansCoeur = new Audio(process.env.PUBLIC_URL + "/assets/sounds/sardaigne_sans_coeur.mp3");
const audioVar1 = new Audio(process.env.PUBLIC_URL + "/assets/sounds/sardaigne_var_1.mp3");
const audioVar2 = new Audio(process.env.PUBLIC_URL + "/assets/sounds/sardaigne_var_2.mp3");

const Sardaigne = (props) => {

    const navigate = useNavigate();

    const [page, setPage] = useState(0);
    const pageRef = useRef(page);

    const [musicPage, setMusicPage] = useState(1);
    const musicPageRef = useRef(musicPage);
    const [frame, setFrame] = useState(1);

    const [useAudioVar1, setUseAudioVar1] = useState(false);
    const [useAudioVar2, setUseAudioVar2] = useState(false);

    const useAudioVar1Ref = useRef(useAudioVar1);
    const useAudioVar2Ref = useRef(useAudioVar2);

    const [isShownVideo, setIsShownVideo] = useState(false);

    const debutPages = [0, 56.3, 117.8, 168.2]
    const dureePages = [56.3, 61.5, 50.4, 25.8]
    const nbFramesParPage = [680, 743, 605, 303]
    const totFrames = [0, 688, 1431, 2036, 2339]
    const frameRateParPage = dureePages.map((d, i) => nbFramesParPage[i] / d);

    const [triangle, setTriangle] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0]);
    const triangleRef = useRef(triangle);

    const alignementNotes = [ //changer ici l'alignement
        [103, 345], // [decalage vertical, echelle verticale]
        [103, 345],
        [103, 345],
        [103, 345],
    ]

    const [boutonOreilleActif, setBoutonOreilleActif] = useState(false);
    const boutonOreilleActifRef = useRef(boutonOreilleActif);

    const [tailleTirroir, setTailleTirroir] = useState({ 'value': 95 });
    const tailleTirroirRef = useRef(tailleTirroir);

    const [isHoveredQuitinaSpectre, setIsHoveredQuitinaSpectre] = useState(false);
    const [isHoveredQuitinaSeule, setIsHoveredQuitinaSeule] = useState(false);

    const [cursorPosZoom, setCursorPosZoom] = useState(0);
    const cursorPosZoomRef = useRef(cursorPosZoom);

    const [cursorPos, setCursorPos] = useState(0);
    const cursorPosRef = useRef(0);

    const [ex1waiting, setEx1waiting] = useState(false);
    const [ex2waiting, setEx2waiting] = useState(false);

    const playMusic = () => {
        if (boutonOreilleActif) {
            audioSansCoeur.play();
            console.log("playing sans coeur");
        } else if (useAudioVar1) {
            audioVar1.play();
            console.log("playing var1");
        } else if (useAudioVar2) {
            audioVar2.play();
            console.log("playing var1");
        } else {
            audio.play();
            console.log("playing normal");
        }
    }

    const pauseMusic = () => {
        if (boutonOreilleActif) {
            audioSansCoeur.pause();
        } else if (useAudioVar1) {
            audioVar1.pause();
        } else if (useAudioVar2) {
            audioVar2.pause();
        } else {
            audio.pause();
        }
    }

    const stopMusic = () => {
        audio.pause();
        audio.currentTime = debutPages[musicPageRef.current - 1];
    }

    const changeMusicPage = (n) => {
        setMusicPage(n);
        musicPageRef.current = n;
        audio.currentTime = debutPages[n - 1] + 0.5;
        pauseMusic();
    }

    const playPage = (n) => {
        if(!boutonOreilleActifRef.current){
            audioSansCoeur.currentTime = 0;
            audioSansCoeur.play();
        }
        else{
        audio.currentTime = 0;
        audio.play();
        }
    }

    //return the frame number corresponding to the time t, indexed since the beginning (must add the previosu frames)
    const getFrameFromTime = (t) => {
        //let f = 0;
        //let i = 0;
        /*while (i < musicPageRef.current - 1) {
            f += nbFramesParPage[i];
            i++;
        }*/
        //f += Math.floor(t * frameRateParPage[musicPageRef.current - 1]) + 1;
        let timeOffset = debutPages[Math.max(Math.min(musicPageRef.current - 1, 3), 0)];
        let f = totFrames[Math.max(Math.min(musicPageRef.current - 1, 3), 0)] + (t - timeOffset) * frameRateParPage[Math.max(Math.min(musicPageRef.current - 1, 3), 0)] + 1;
        /*console.log("frame : " + f);
        console.log("time offset : " + timeOffset);
        console.log("time : " + t);
        console.log("base page : " + totFrames[musicPageRef.current - 1]);
        console.log("adding : " + (t - timeOffset) * frameRateParPage[musicPageRef.current - 1]);*/
        f = f <= 5 ? 1 : Math.floor(f / 5) * 5;
        return f;
    }

    const getFrameNumber = () => {
        let f = 0
        if (boutonOreilleActifRef.current) {
            f = getFrameFromTime(audioSansCoeur.currentTime);
        } else {
            f = getFrameFromTime(audio.currentTime);
        }

        if (f !== NaN) {
            return f
        } else {
            return 1
        }
    }

    //Page 1 specific :
    const goToPage1 = () => {
        setPage(1);
        pageRef.current = 1;
        //The 4 pictures must appaeared succesively
        let tl = anime.timeline();
        tl.add({
            targets: '.img-chanteur-4',
            opacity: 1,
            duration: 600,
            easing: 'easeInSine',
        }, 0)
            .add({
                targets: '.img-chanteur-3',
                opacity: 1,
                duration: 600,
                easing: 'easeInSine',
            }, 600)
            .add({
                targets: '.img-chanteur-2',
                opacity: 1,
                duration: 600,
                easing: 'easeInSine',
            }, 1200)
            .add({
                targets: '.img-chanteur-1',
                opacity: 1,
                duration: 600,
                easing: 'easeInSine',
            }, 1800)
            .add({
                targets: '#cd_name',
                opacity: 0,
                duration: 600,
                easing: 'easeInSine',
            }, 1800)
            .add({
                targets: '.playeranim',
                opacity: 1,
                duration: 600,
                easing: 'easeInSine',
            }, 2400)

    }

    //Page 2 specific :
    const goToPage2 = () => {
        let tl = anime.timeline();
        tl.add({
            targets: '.explications_button1',
            opacity: 0,
            duration: 600,
            easing: 'easeInSine',
        }, 0)
            .add({
                targets: '.explications_button2',
                opacity: 1,
                duration: 600,
                easing: 'easeInSine',
            }, 1600)
            .add({
                targets: '.explications_button2',
                opacity: 0,
                duration: 600,
                easing: 'easeInSine',
            }, 4000)

        setTimeout(() => {
            audio.currentTime = 0;
            pageRef.current = 2;
            setPage(2);
        }, 4800)
    }

    const changementCanal = () => {
        if (!boutonOreilleActifRef.current) {
            audioSansCoeur.currentTime = audio.currentTime;
            audio.currentTime = 0;
            audio.pause();
            //audioSansCoeur.play();
        } else {
            audio.currentTime = audioSansCoeur.currentTime;
            audioSansCoeur.pause();
            //audio.play();
        }
        setBoutonOreilleActif(!boutonOreilleActif);
        boutonOreilleActifRef.current = !boutonOreilleActifRef.current;
    }

    //Page 3 specific :
    const goToPage3 = () => {
        setShowTirroir(true);
        let tl = anime.timeline();
        tl.add({
            targets: tailleTirroir,
            value: 570,
            duration: 1000,
            easing: 'linear',
            update: function () {
                tailleTirroirRef.current = { 'value': tailleTirroir.value };
                setTailleTirroir(tailleTirroirRef.current);
            }
        }, 1000)
            .add({
                targets: '.explications_spectre',
                opacity: 0,
                duration: 600,
                easing: 'easeInSine',
            }, 0)
        setTimeout(() => {
            pageRef.current = 3;
            setPage(3);
            setShowTirroir(false);
        }, 2100);

        //reset son
        console.log("reset son");
        if (boutonOreilleActifRef.current) {
            audioSansCoeur.currentTime = 0;
            audioSansCoeur.pause();
            changementCanal();
        } else {
            audio.currentTime = 0;
            audio.pause();
        }
    }

    const [showTirroir, setShowTirroir] = useState(false);
    const [quintinaSeule, setQuintinaSeule] = useState(false);
    const [gommeHover, setGommeHover] = useState(false);
    const [showZoomSpectre, setShowZoomSpectre] = useState(false);
    const [showExplications1, setShowExplications1] = useState(false);
    const [showExplications2, setShowExplications2] = useState(false);
    const [pageExplications, setPageExplications] = useState(1);

    const goToPage2From3 = () => {
        setShowTirroir(true);
        setPage(2);
        pageRef.current = 2;
        let tl = anime.timeline();
        tl.add({
            targets: tailleTirroir,
            value: 85,
            duration: 1000,
            easing: 'linear',
            update: function () {
                tailleTirroirRef.current = { 'value': tailleTirroir.value };
                setTailleTirroir(tailleTirroirRef.current);
            }
        })

        //reset son
        if (boutonOreilleActifRef.current) {
            audioSansCoeur.currentTime = 0;
            audioSansCoeur.pause();
            changementCanal();
        } else {
            audioSansCoeur.currentTime = 0;
            audio.pause();
        }
    }

    const gomme1 = () => {
        /* pause all sound */
        if (boutonOreilleActifRef.current) {
            audioSansCoeur.currentTime = 0;
            audioSansCoeur.pause();
        } else {
            audio.currentTime = 0;
            audio.pause();
        }

        let tl = anime.timeline();
        tl.add({
            targets: '.gomme',
            opacity: 1,
            duration: 1
        }, 0)
            .add({
                targets: '.gomme',
                left: 202 + 41,
                duration: 1000,
                easing: 'linear',
            }, 0)
            .add({
                targets: '.lignerouge',
                left: 202 + 41,
                width: 0,
                duration: 1000,
                easing: 'linear',
            }, 0)
            .add({
                targets: '.gomme',
                opacity: 0,
                duration: 1
            }, 1100)
        /*setTimeout(() => {
            setShowExplications1(true);
        }, 1100);*/
        setEx1waiting(true);
        setUseAudioVar1(true);
        useAudioVar1Ref.current = true;
        setUseAudioVar2(false);
        useAudioVar2Ref.current = false;
    }

    const gomme2 = () => {
        audioVar1.currentTime = 0;
        audioVar1.pause();

        setShowExplications1(false);
        let tl = anime.timeline();
        tl.add({
            targets: '.lignerouge',
            width: 202,
            left: 41,
            duration: 1,
            easing: 'linear',
        }, 0)
            .add({
                targets: '.gomme2',
                opacity: 1,
                duration: 1
            }, 0)
            .add({
                targets: '.ligneorange',
                opacity: 1,
                duration: 1,
                easing: 'linear',
            }, 0)
            .add({
                targets: '.gomme2',
                left: 114 + 47,
                duration: 1000,
                easing: 'linear',
            }, 0)
            .add({
                targets: '.ligneblanche',
                width: 47,
                duration: 1000,
                easing: 'linear',
            }, 0)
            .add({
                targets: '.gomme2',
                opacity: 0,
                duration: 1
            }, 1100)
        /*setTimeout(() => {
            setShowExplications2(true);
        }, 1100);*/
        setEx2waiting(true);
        setUseAudioVar1(false);
        useAudioVar1Ref.current = false;
        setUseAudioVar2(true);
        useAudioVar2Ref.current = true;
    }

    const reset = () => {
        //reset position gomme
        let tl = anime.timeline();
        tl.add({
            targets: '.gomme',
            left: 39,
            duration: 1,
            easing: 'linear',
        }, 0)
        tl.add({
            targets: '.gomme2',
            left: 114,
            duration: 1,
            easing: 'linear',
        }, 0)
        //reset lignes
        tl.add({
            targets: '.ligneorange',
            opacity: 0,
            duration: 1,
            easing: 'linear',
        }, 0)
            .add({
                targets: '.ligneblanche',
                width: 0,
                duration: 1,
                easing: 'linear',
            }, 0)
        setPageExplications(1);
        setShowExplications2(false);
        setShowExplications1(false);
        setShowZoomSpectre(false);
        setUseAudioVar1(false);
        useAudioVar1Ref.current = false;
        setUseAudioVar2(false);
        useAudioVar2Ref.current = false;
        setEx1waiting(false);
        setEx2waiting(false);
    }

    const getCursorPos = () => {
        //Calculate cursor position for audioVar1 and audioVar2 depending on the lentgh of the audio of the music
        //The cursor has a position between 0 and 243
        let pos = 0;
        if (useAudioVar1Ref.current) {
            pos = Math.floor(audioVar1.currentTime * 242 / audioVar1.duration);
        }
        if (useAudioVar2Ref.current) {
            pos = Math.floor(audioVar2.currentTime * 242 / audioVar2.duration);
        }
        //console.log(audioVar1.currentTime, pos);
        return pos;
    }

    //Tout
    const keypointFrame = [120, 180, 260, 325, 350, 370, 390, 410, 450];


    function clearAll() {
        props.audio.forEach(audio => audio.pause());
    }

    useEffect(() => {
        clearAll();

        props.audio.push(audio);
        props.audio.push(audioSansCoeur);
        props.audio.push(audioVar1);
        props.audio.push(audioVar2);

        console.log('starting...');
        setInterval(() => {
            let f = getFrameNumber();
            //console.log(f);
            //console.log('page ' + pageRef.current);
            if (pageRef.current === 1) {
                if (f > 2339) {
                    setFrame(1);
                    audio.currentTime = 0;
                    audio.pause();
                }
            }
            else if (pageRef.current === 2) {
                if (f > 520) {
                    triangleRef.current = [0, 0, 0, 0, 0, 0, 0, 0, 0];
                    setTriangle(triangleRef.current);
                    audio.currentTime = 0;
                    audio.pause();
                    audioSansCoeur.currentTime = 0;
                    audioSansCoeur.pause();
                }
                for (let i = 0; i < 9; i++) {
                    if (f > keypointFrame[i]) {
                        let newTriangle = triangleRef.current;
                        newTriangle[i] = 1;
                        triangleRef.current = newTriangle;
                        setTriangle(newTriangle);
                    }
                }
            }
            else if (pageRef.current === 3) {
                if (audio.currentTime > 42.26 || audioSansCoeur.currentTime > 42.26) {
                    audio.currentTime = 0;
                    audio.pause();
                    audioSansCoeur.currentTime = 0;
                    audioSansCoeur.pause();
                }

                // calcul position curseur : entre 0 et 540, alors que la musique joue entre 0 et 42.26(dureePage[0])
                if (boutonOreilleActifRef.current) {
                    cursorPosZoomRef.current = audioSansCoeur.currentTime * 540 / 42.26;
                }
                else {
                    cursorPosZoomRef.current = audio.currentTime * 540 / 42.26;
                }
                //console.log('cursorPosZoomRef.current : ' + cursorPosZoomRef.current);
                setCursorPosZoom(cursorPosZoomRef.current);
            }
            setFrame(f);
            //set musicpage accordingly
            let j = 0
            while (f >= totFrames[j]) {
                j++;
            }
            if (j !== musicPageRef.current) {
                setMusicPage(j);
                musicPageRef.current = j;
            }
            //console.log('musicPageRef.current : ' + musicPageRef.current);
        }, 80);

        let tl = anime.timeline();
        tl.add({
            targets: '.back',
            opacity: 0.5,
            duration: 600,
            easing: 'easeInSine',
        }, 1500)
            .add({
                targets: '.animIntro',
                opacity: 0.95,
                duration: 600,
                easing: 'easeInSine',
            }, 1300)
            .add({
                targets: '#titleanim',
                opacity: 1,
                duration: 600,
                easing: 'easeInSine',
            }, 2400)
            .add({
                targets: '#label1',
                opacity: 1,
                duration: 600,
                easing: 'easeInSine',
            }, 3800)
            .add({
                targets: '#label2',
                opacity: 1,
                duration: 600,
                easing: 'easeInSine',
            }, 5500)
            .add({
                targets: '#label1',
                opacity: 0,
                duration: 600,
                easing: 'easeInSine',
            }, 5600)
            .add({
                targets: '#label2',
                opacity: 0,
                duration: 600,
                easing: 'easeInSine',
            }, 9600)
            .add({
                targets: '.content',
                opacity: 1,
                duration: 800,
                easing: 'easeInSine',
            }, 9800)

        setInterval(() => {
            if (pageRef.current === 3) {
                let pos = getCursorPos();
                cursorPosRef.current = pos;
                setCursorPos(cursorPosRef.current);
            }
        }, 40);

        audioVar1.preload = "auto";
        audioVar2.preload = "auto";
        audio.preload = "auto";
        audioSansCoeur.preload = "auto";
    }, []);

    return (
        <>
            
            <div
                style={{
                    opacity: page === 0 ? 1 : 0,
                }}
            >
                <div>
                    <div className="background"
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            backgroundColor: 'black',
                        }} />

                    <img
                        className='back'
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            zIndex: 1,
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/back.jpg"}
                    />
                    <div
                        className='animIntro'
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            height: 500,
                            width: 110,
                            zIndex: 2,
                            opacity: 0,
                            backgroundColor: 'black',
                        }}
                    />
                    <FramePlayer dirName="intro_sard"
                        className="animIntro"
                        frameNumber={12}
                        fps={12}
                        initialDelay={1500}
                        style={{
                            zIndex: 2,
                            width: '660px',
                            height: '500px',
                            opacity: 0,
                        }}
                    />
                    {/* white label 1 */}
                    <div
                        id="label1"
                        style={{
                            position: 'absolute',
                            top: '410px',
                            left: '140px',
                            width: '470px',
                            height: '40px',
                            color: 'white',
                            opacity: 0,
                            zIndex: 3,
                        }}
                    >
                        En collaboration avec Bernard Lortat-Jacob<br />
                        avec le concours de Michèle Castellangelo et de Gilles Léothaud.
                    </div>
                    {/* white label 2 */}
                    <div
                        id="label2"
                        style={{
                            position: 'absolute',
                            top: '220px',
                            left: '190px',
                            width: '470px',
                            height: '40px',
                            color: 'white',
                            opacity: 0,
                            zIndex: 3,
                            fontSize: '20px',
                            fontFamily: 'Times New Roman',
                        }}
                    >
                        Quatre hommes chantent, <br />
                        et on entend une cinquième voix.
                    </div>
                    <h2
                        id="titleanim"
                        style={{
                            position: 'absolute',
                            top: '50px',
                            left: '120px',
                            zIndex: 3,
                            color: 'orange',
                            opacity: 0,
                            fontSize: '30px',
                            fontFamily: 'Times New Roman',
                        }}
                    >
                        Polyphonie vocale de Sardaigne
                    </h2>
                    <div className="content"
                        style={{
                            opacity: 0,
                        }}>
                        <div
                            style={{
                                position: 'absolute',
                                top: '150px',
                                left: '120px',
                                zIndex: 3,
                                width: '400px',
                                height: '200px',
                                overflow: 'scroll',
                                color: 'white',
                            }}
                        >
                            Dans le gros bourg de Castelsardo, au nord de la Sardaigne, le rituel de la Semaine Sainte est sous la compétence exclusive d'une confrérie, composée d'une petite centaine d'hommes : pêcheurs, artisans, commerçants (plus quelques cadres, d'ailleurs peu nombreux).<br />
                            Le Lundi saint est la grande fête de Castelsardo, une fête qui se prépare durant toute l'année. Or, préparer cette fête consiste surtout à préparer les chœurs qui devront chanter en procession durant une grande partie de la nuit lors de la procession des « mystères ».<br />
                            Ce répertoire de la confrérie est pleinement maîtrisé par les chanteurs et encore très vivant. Il est de stricte tradition orale et remonterait au moins au XVIème siècle. Il est probable qu'il s'exécute sans grand changement depuis cette époque.<br />
                            À Castelsardo, chaque Lundi saint donc, de nombreux chanteurs sont « candidats » au chant et attendent d'être choisis par leur Prieur. Celui-ci compose trois choeurs, comprenant chacun toujours quatre chanteurs.<br />
                            Ces douze chanteurs sont les « apôtres » du Lundi saint. Ils s'adonneront à une sorte de compétition rituelle et vocale très éprouvante, durant plusieurs heures. Le premier chœur chante le Miserere (psaume 50); le deuxième, le Stabba (Stabat Mater); le troisième, le Jesu.<br />
                            Ces chants font penser à de longues lamentations : le texte en latin semble à peine prononcé (pour les chanteurs, il est d'ailleurs relativement secondaire puisque, la plupart du temps, ils n'en comprennent pas le sens). Ce sont des chants « de voyelles », pourrait-on dire, qui retiennent l'attention par leur grande beauté et leurs qualités spectrales spécifiques.<br />
                        </div>
                        <div
                            style={{
                                cursor: 'pointer',
                            }}
                        >
                            <img
                                style={{
                                    position: 'absolute',
                                    top: '380px',
                                    left: '120px',
                                    zIndex: 5,
                                }}
                                src={process.env.PUBLIC_URL + "/assets/images/sardaigne/bt2.png"}
                            />
                            <p
                                style={{
                                    position: 'absolute',
                                    top: '380px',
                                    left: '160px',
                                    zIndex: 5,
                                    color: 'lightgray',
                                    fontSize: '14px',
                                    textDecoration: 'underline',
                                }}
                                onMouseEnter={(event) => {
                                    event.target.style.color = 'white';
                                }}
                                onMouseLeave={(event) => {
                                    event.target.style.color = 'lightgray';
                                }}
                                onClick={() => { setIsShownVideo(true) }}
                            >
                                Vidéo
                            </p>
                            <HomeButton />
                        </div>

                        <div
                            style={{
                                cursor: 'pointer',
                            }}
                            onClick={() => { goToPage1() }}
                        >
                            <img
                                style={{
                                    position: 'absolute',
                                    top: '420px',
                                    left: '550px',
                                    zIndex: 5,
                                }}
                                src={process.env.PUBLIC_URL + "/assets/images/sardaigne/bt1.png"}
                            />
                            <p style={{
                                position: 'absolute',
                                top: '400px',
                                left: '375px',
                                zIndex: 5,
                                color: 'lightgray',
                                fontSize: '14px',
                                textDecoration: 'underline',
                            }}
                                onMouseEnter={(event) => {
                                    event.target.style.color = 'white';
                                }}
                                onMouseLeave={(event) => {
                                    event.target.style.color = 'lightgray';
                                }}
                            >
                                <span style={{ textDecoration: 'normal' }}>&gt;&nbsp; </span>
                                Ecoute et transcription
                            </p>
                        </div>
                    </div>
                </div>

                {/* media player */}
                {isShownVideo &&
                    //video tag, 600x500
                    <div
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            zIndex: 20,
                            width: '660px',
                            height: '500px',
                            backgroundColor: 'black',
                        }}
                    >
                        <video
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                zIndex: 23,
                                width: '660px',
                                height: '500px',
                            }}
                            src={process.env.PUBLIC_URL + "/assets/movies/sard_video.mp4"}
                            controls
                            autoPlay
                            onEnded={() => {
                                setIsShownVideo(false);
                            }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/sardaigne/cross.png"}
                            alt="Close"
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                width: '32px',
                                height: '32px',
                                zIndex: 25,
                                cursor: 'pointer',
                            }}
                            onClick={() => setIsShownVideo(false)}
                        />
                    </div>
                }
            </div>

            {/* page 1 : notes */}
            <div
                style={{
                    opacity: page === 1 ? 1 : 0,
                }}
            >
                <div className="background"
                    style={{
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        backgroundColor: '#5b6595',
                    }} />
                <div
                    style={{
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        width: '660px',
                        height: '25px',
                        zIndex: 4,
                        backgroundColor: '#5b6595',
                    }}
                />
                <p
                    style={{
                        position: 'absolute',
                        top: '5px',
                        left: '60px',
                        color: 'white',
                        fontFamily: 'Times New Roman',
                        fontSize: '18px',
                        zIndex: 4,
                        margin: 0,
                        fontWeight: 'bold',
                    }}
                >
                    Polyphonie vocale de Sardaigne
                </p>
                <div
                    style={{
                        position: 'absolute',
                        top: '0px',
                        left: '650px',
                        width: '10px',
                        height: '500px',
                        zIndex: 4,
                        backgroundColor: '#5b6595',
                    }}
                />
                <img src={process.env.PUBLIC_URL + "/assets/images/sardaigne/note.png"}
                    style={{
                        position: 'absolute',
                        top: '1px',
                        left: '0px',
                        zIndex: 1,
                        width: '660px',
                        height: '490px',
                    }}
                />
                <img
                    className='playeranim'
                    src={process.env.PUBLIC_URL + "/assets/images/sardaigne/b_note.png"}
                    style={{
                        position: 'absolute',
                        top: '35px',
                        left: '105px',
                        zIndex: 2,
                        cursor: 'pointer',
                        opacity: 0,
                    }}
                    onClick={() => goToPage2()}
                />
                <p
                    className='playeranim explications_button1'
                    style={{
                        position: 'absolute',
                        top: '35px',
                        left: '195px',
                        zIndex: 2,
                        color: 'white',
                        opacity: 0,
                        fontSize: '16px',
                        fontFamily: 'Times New Roman',
                    }}>
                    La cinquième voix se trouve au-dessus des voix transcrites. <br />
                    Elle n'est émise par aucun chanteur.
                </p>
                <p
                    className='explications_button2'
                    style={{
                        position: 'absolute',
                        top: '35px',
                        left: '185px',
                        zIndex: 2,
                        color: 'white',
                        opacity: 0,
                        fontSize: '16px',
                        fontFamily: 'Times New Roman',
                    }}>
                    Cette cinquième voix est dénommée <i> la quintina</i>.
                </p>
                <div
                    id="cd_name"
                    style={{
                        position: 'absolute',
                        top: '146px',
                        left: '117px',
                        width: '513px',
                        height: '300px',
                        zIndex: 3,
                        backgroundColor: '#5b6595',
                        opacity: 1,
                    }}
                >
                    <p style={{
                        position: 'absolute',
                        top: '115px',
                        left: '100px',
                        zIndex: 2,
                        color: 'white',
                        textAlign: 'center',
                        opacity: 1,
                    }} >
                        <span style={{ fontFamily: "Times New Roman" }}>Jesu</span><br />
                        extrait de la plage 6 du CD encarté dans le livre <br />
                        chants de passion, Le Cerf, 1998
                    </p>
                </div>
                <div
                    style={{
                        position: 'absolute',
                        top: '134px',
                        left: '100px',
                        zIndex: 2,
                        width: '545px',
                        height: '326px',
                        backgroundColor: 'white',
                    }}
                />
                {/*
                <div
                    style={{
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        width: '660px',
                        height: '500px',
                        zIndex: 3,
                    }}
                >
                    <img src={process.env.PUBLIC_URL + "/assets/images/sardaigne/note1.svg"}
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            zIndex: 4,
                            width: '660px',
                            opacity: 0.5,
                        }}
                    />
                    <div className='mask'
                        style={{
                            maskImage: 'url(' + process.env.PUBLIC_URL + "/assets/images/sardaigne/note1.svg" + ')',
                            maskRepeat</p>: 'no-repeat',
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            zIndex: 5,
                            width: '660px',
                        }}
                    >
                        <img src={process.env.PUBLIC_URL + "/assets/images/sardaigne/mask1/34.svg"}/>
                    </div>
                    </div> */}

                <img
                    className="img-chanteur-1"
                    style={{
                        position: 'absolute',
                        top: '145px',
                        left: '34px',
                        zIndex: 3,
                        opacity: 0,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/sardaigne/m1.jpg"}
                />
                <p
                    className='img-chanteur-1'
                    style={{
                        position: 'absolute',
                        top: '146px',
                        left: '126px',
                        zIndex: 3,
                        color: 'black',
                        fontSize: '12px',
                        fontStyle: 'italic',
                        fontFamily: 'Times New Roman',
                        opacity: 0,
                    }}
                >
                    falzittu
                </p>
                <img
                    className='playeranim'
                    style={{
                        position: 'absolute',
                        top: '157px',
                        left: '106px',
                        zIndex: 3,
                        opacity: 0,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/sardaigne/n1.svg"}
                />
                <img
                    className='img-chanteur-2'
                    style={{
                        position: 'absolute',
                        top: '224px',
                        left: '34px',
                        zIndex: 3,
                        opacity: 0,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/sardaigne/m2.jpg"}
                />
                <p
                    className='img-chanteur-2'
                    style={{
                        position: 'absolute',
                        top: '218px',
                        left: '126px',
                        zIndex: 3,
                        color: 'black',
                        fontSize: '12px',
                        fontStyle: 'italic',
                        fontFamily: 'Times New Roman',
                        opacity: 0,
                    }}
                >
                    bogi
                </p>
                <img
                    className='playeranim'
                    style={{
                        position: 'absolute',
                        top: '246px',
                        left: '105px',
                        zIndex: 3,
                        opacity: 0,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/sardaigne/n2.svg"}
                />
                <img
                    className='img-chanteur-3'
                    style={{
                        position: 'absolute',
                        top: '306px',
                        left: '34px',
                        zIndex: 3,
                        opacity: 0,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/sardaigne/m3.jpg"}
                />
                <p
                    className='img-chanteur-3'
                    style={{
                        position: 'absolute',
                        top: '290px',
                        left: '126px',
                        zIndex: 3,
                        color: 'black',
                        fontSize: '12px',
                        fontStyle: 'italic',
                        fontFamily: 'Times New Roman',
                        opacity: 0,
                    }}
                >
                    contra
                </p>
                <img
                    className='playeranim'
                    style={{
                        position: 'absolute',
                        top: '316px',
                        left: '105px',
                        zIndex: 3,
                        opacity: 0,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/sardaigne/n2.svg"}
                />
                <img
                    className='img-chanteur-4'
                    style={{
                        position: 'absolute',
                        top: '381px',
                        left: '34px',
                        zIndex: 3,
                        opacity: 0,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/sardaigne/m4.jpg"}
                />
                <p
                    className='img-chanteur-4'
                    style={{
                        position: 'absolute',
                        top: '360px',
                        left: '126px',
                        zIndex: 3,
                        color: 'black',
                        fontSize: '12px',
                        fontStyle: 'italic',
                        fontFamily: 'Times New Roman',
                        opacity: 0,
                    }}
                >
                    bassu
                </p>
                <img
                    className='playeranim'
                    style={{
                        position: 'absolute',
                        top: '387px',
                        left: '105px',
                        zIndex: 3,
                        opacity: 0,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/sardaigne/n2.svg"}
                />

                {/* lignes 1 */}
                <div
                    className='playeranim'
                    style={{
                        position: 'absolute',
                        top: '173px', //PB41 modification de la hauteur de la portée
                        left: '105px',
                        width: '540px',
                        height: '30px',
                        zIndex: 3,
                        opacity: 0,
                    }}
                >
                    <svg viewBox='0 0 540 30'
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <line x1="0" y1="1" x2="540" y2="1" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="8" x2="540" y2="8" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="15" x2="540" y2="15" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="22" x2="540" y2="22" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="29" x2="540" y2="29" stroke="black" strokeWidth="1" />
                    </svg>
                </div>
                {/* lignes 2 */}
                <div
                    className='playeranim'
                    style={{
                        position: 'absolute',
                        top: '243px',
                        left: '105px',
                        width: '540px',
                        height: '30px',
                        zIndex: 3,
                        opacity: 0,
                    }}
                >
                    <svg viewBox='0 0 540 30'
                        style={{
                            position: 'absolute',
                            top: '2px',
                            left: '0px',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <line x1="0" y1="1" x2="540" y2="1" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="8" x2="540" y2="8" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="15" x2="540" y2="15" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="22" x2="540" y2="22" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="29" x2="540" y2="29" stroke="black" strokeWidth="1" />
                    </svg>
                </div>
                {/* lignes 3 */}
                <div
                    className='playeranim'
                    style={{
                        position: 'absolute',
                        top: '315px',
                        left: '105px',
                        width: '540px',
                        height: '30px',
                        zIndex: 3,
                        opacity: 0,
                    }}
                >
                    <svg viewBox='0 0 540 30'
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <line x1="0" y1="1" x2="540" y2="1" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="8" x2="540" y2="8" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="15" x2="540" y2="15" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="22" x2="540" y2="22" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="29" x2="540" y2="29" stroke="black" strokeWidth="1" />
                    </svg>
                </div>
                {/* lignes 4 */}
                <div
                    className='playeranim'
                    style={{
                        position: 'absolute',
                        top: '385px',
                        left: '105px',
                        width: '540px',
                        height: '30px',
                        zIndex: 3,
                        opacity: 0,
                    }}
                >
                    <svg viewBox='0 0 540 30'
                        style={{
                            position: 'absolute',
                            top: '-2px',
                            left: '0px',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <line x1="0" y1="1" x2="540" y2="1" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="8" x2="540" y2="8" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="15" x2="540" y2="15" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="22" x2="540" y2="22" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="29" x2="540" y2="29" stroke="black" strokeWidth="1" />
                    </svg>
                </div>

                {/*current frame */}
                <img
                    className='playeranim'
                    style={{
                        position: 'absolute',
                        top: alignementNotes[Math.min(3, Math.max(0, musicPageRef.current - 1))][0],
                        left: '115px',
                        height: alignementNotes[Math.min(3, Math.max(0, musicPageRef.current - 1))][1],
                        width: 531.217,
                        zIndex: 3,
                        opacity: 0,
                    }}
                    src={page == 1 ? process.env.PUBLIC_URL + `/assets/images/sardaigne/notes/${frame}.svg` : 'none'}
                />

                <div
                    className='playeranim controls'
                    style={{
                        position: 'absolute',
                        top: '462px',
                        left: '101px',
                        width: '540px',
                        height: '23px',
                        zIndex: 3,
                        border: '2px outset black',
                        backgroundColor: '#1c2378',
                        opacity: 0,
                    }}
                >
                    <img
                        style={{
                            position: 'absolute',
                            top: '-17px',
                            left: '6px',
                            zIndex: 3,
                            cursor: 'pointer',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/play.png"}
                        onClick={playMusic}
                    />
                    <img
                        style={{
                            position: 'absolute',
                            top: '-17px',
                            left: '28px',
                            zIndex: 3,
                            cursor: 'pointer',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/pause.png"}
                        onClick={pauseMusic}
                    />
                    <img
                        style={{
                            position: 'absolute',
                            top: '-17px',
                            left: '54px',
                            zIndex: 3,
                            cursor: 'pointer',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/stop.png"}
                        onClick={stopMusic}
                    />
                    <div
                        style={{
                            position: 'absolute',
                            top: '2px',
                            left: '118px',
                            zIndex: 3,
                            border: '1px inset black',
                            height: '17px',
                            width: '356px',
                        }}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                zIndex: 3,
                                color: 'white',
                                fontSize: '10px',
                                fontFamily: 'Times New Roman',
                                border: musicPageRef.current === 1 ? '1px solid black' : 'none',
                                backgroundColor: musicPageRef.current === 1 ? '#686eab' : '#1c2378',
                                padding: '2px',
                                cursor: 'pointer',
                                width: '80px',
                                textAlign: 'center',
                                height: '11px',
                            }}
                            onClick={() => changeMusicPage(1)}
                        >
                            PAGE 1
                        </div>
                        <div
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '90px',
                                zIndex: 3,
                                color: 'white',
                                fontSize: '10px',
                                fontFamily: 'Times New Roman',
                                border: musicPageRef.current === 2 ? '1px solid black' : 'none',
                                backgroundColor: musicPageRef.current === 2 ? '#686eab' : '#1c2378',
                                padding: '2px',
                                cursor: 'pointer',
                                width: '80px',
                                textAlign: 'center',
                                height: '11px',
                            }}
                            onClick={() => changeMusicPage(2)}
                        >
                            PAGE 2
                        </div>
                        <div
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '180px',
                                zIndex: 3,
                                color: 'white',
                                fontSize: '10px',
                                fontFamily: 'Times New Roman',
                                border: musicPageRef.current === 3 ? '1px solid black' : 'none',
                                backgroundColor: musicPageRef.current === 3 ? '#686eab' : '#1c2378',
                                padding: '2px',
                                cursor: 'pointer',
                                width: '80px',
                                textAlign: 'center',
                                height: '11px',
                            }}
                            onClick={() => changeMusicPage(3)}
                        >
                            PAGE 3
                        </div>
                        <div
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '270px',
                                zIndex: 3,
                                color: 'white',
                                fontSize: '10px',
                                fontFamily: 'Times New Roman',
                                border: musicPageRef.current === 4 ? '1px solid black' : 'none',
                                backgroundColor: musicPageRef.current === 4 ? '#686eab' : '#1c2378',
                                padding: '2px',
                                cursor: 'pointer',
                                width: '80px',
                                textAlign: 'center',
                                height: '11px',
                            }}
                            onClick={() => changeMusicPage(4)}
                        >
                            PAGE 4
                        </div>
                    </div>
                </div>
            </div>

            {/* page 2 : zoom */}
            <div
                style={{
                    opacity: page === 2 ? 1 : 0,
                }}
            >
                <div className="background"
                    style={{
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        backgroundColor: '#686eab',
                    }} />
                <img src={process.env.PUBLIC_URL + "/assets/images/sardaigne/note.png"}
                    style={{
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        zIndex: 1,
                        width: '660px'
                    }}
                />
                <div
                    style={{
                        position: 'absolute',
                        top: '34px',
                        left: '100px',
                        zIndex: 2,
                        width: '435px',
                        height: '80px',
                        backgroundColor: boutonOreilleActif ? '#a1898c' : 'white',
                    }}
                />
                <div
                    style={{
                        position: 'absolute',
                        top: '134px',
                        left: '100px',
                        zIndex: 2,
                        width: '435px',
                        height: '326px',
                        backgroundColor: 'white',
                    }}
                />
                {/*
                <div
                    style={{
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        width: '660px',
                        height: '500px',
                        zIndex: 3,
                    }}
                >
                    <img src={process.env.PUBLIC_URL + "/assets/images/sardaigne/note1.svg"}
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            zIndex: 4,
                            width: '660px',
                            opacity: 0.5,
                        }}
                    />
                    <div className='mask'
                        style={{
                            maskImage: 'url(' + process.env.PUBLIC_URL + "/assets/images/sardaigne/note1.svg" + ')',
                            maskRepeat: 'no-repeat',
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            zIndex: 5,
                            width: '660px',
                        }}
                    >
                        <img src={process.env.PUBLIC_URL + "/assets/images/sardaigne/mask1/34.svg"}/>
                    </div>
                    </div> */}

                <img
                    style={{
                        position: 'absolute',
                        top: '157px',
                        left: '106px',
                        zIndex: 3,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/sardaigne/n1.svg"}
                />
                <img
                    style={{
                        position: 'absolute',
                        top: '246px',
                        left: '105px',
                        zIndex: 3,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/sardaigne/n2.svg"}
                />

                <img
                    style={{
                        position: 'absolute',
                        top: '316px',
                        left: '105px',
                        zIndex: 3,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/sardaigne/n2.svg"}
                />
                <img
                    style={{
                        position: 'absolute',
                        top: '387px',
                        left: '105px',
                        zIndex: 3,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/sardaigne/n2.svg"}
                />
                <img
                    style={{
                        position: 'absolute',
                        top: '47px',
                        left: '106px',
                        zIndex: 3,
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/sardaigne/n1.svg"}
                />
                <p
                    className='img-chanteur-1'
                    style={{
                        position: 'absolute',
                        top: '146px',
                        left: '126px',
                        zIndex: 3,
                        color: 'black',
                        fontSize: '12px',
                        fontStyle: 'italic',
                        fontFamily: 'Times New Roman',
                    }}
                >
                    falzittu
                </p>
                <p
                    className='img-chanteur-2'
                    style={{
                        position: 'absolute',
                        top: '218px',
                        left: '126px',
                        zIndex: 3,
                        color: 'black',
                        fontSize: '12px',
                        fontStyle: 'italic',
                        fontFamily: 'Times New Roman',
                    }}
                >
                    bogi
                </p>
                <p
                    className='img-chanteur-3'
                    style={{
                        position: 'absolute',
                        top: '290px',
                        left: '126px',
                        zIndex: 3,
                        color: 'black',
                        fontSize: '12px',
                        fontStyle: 'italic',
                        fontFamily: 'Times New Roman',
                    }}
                >
                    contra
                </p>
                <p
                    className='img-chanteur-4'
                    style={{
                        position: 'absolute',
                        top: '360px',
                        left: '126px',
                        zIndex: 3,
                        color: 'black',
                        fontSize: '12px',
                        fontStyle: 'italic',
                        fontFamily: 'Times New Roman',
                    }}
                >
                    bassu
                </p>

                {/* lignes 1 */}
                <div
                    style={{
                        position: 'absolute',
                        top: '175px',
                        left: '105px',
                        width: '409px',
                        height: '30px',
                        zIndex: 3,
                    }}
                >
                    <svg viewBox='0 0 409 30'
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <line x1="0" y1="1" x2="540" y2="1" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="8" x2="540" y2="8" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="15" x2="540" y2="15" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="22" x2="540" y2="22" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="29" x2="540" y2="29" stroke="black" strokeWidth="1" />
                    </svg>
                </div>
                {/* lignes 2 */}
                <div
                    style={{
                        position: 'absolute',
                        top: '245px',
                        left: '105px',
                        width: '409px',
                        height: '30px',
                        zIndex: 3,
                    }}
                >
                    <svg viewBox='0 0 409 30'
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <line x1="0" y1="1" x2="540" y2="1" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="8" x2="540" y2="8" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="15" x2="540" y2="15" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="22" x2="540" y2="22" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="29" x2="540" y2="29" stroke="black" strokeWidth="1" />
                    </svg>
                </div>
                {/* lignes 3 */}
                <div
                    style={{
                        position: 'absolute',
                        top: '315px',
                        left: '105px',
                        width: '409px',
                        height: '30px',
                        zIndex: 3,
                    }}
                >
                    <svg viewBox='0 0 409 30'
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <line x1="0" y1="1" x2="540" y2="1" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="8" x2="540" y2="8" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="15" x2="540" y2="15" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="22" x2="540" y2="22" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="29" x2="540" y2="29" stroke="black" strokeWidth="1" />
                    </svg>
                </div>
                {/* lignes 4 */}
                <div
                    style={{
                        position: 'absolute',
                        top: '385px',
                        left: '105px',
                        width: '409px',
                        height: '30px',
                        zIndex: 3,
                    }}
                >
                    <svg viewBox='0 0 409 30'
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <line x1="0" y1="1" x2="540" y2="1" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="8" x2="540" y2="8" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="15" x2="540" y2="15" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="22" x2="540" y2="22" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="29" x2="540" y2="29" stroke="black" strokeWidth="1" />
                    </svg>
                </div>
                {/* lignes 5 */}
                <div
                    style={{
                        position: 'absolute',
                        top: '65px',
                        left: '105px',
                        width: '409px',
                        height: '30px',
                        zIndex: 3,
                    }}
                >
                    <svg viewBox='0 0 409 30'
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <line x1="0" y1="1" x2="540" y2="1" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="8" x2="540" y2="8" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="15" x2="540" y2="15" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="22" x2="540" y2="22" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="29" x2="540" y2="29" stroke="black" strokeWidth="1" />
                        <line x1="0" y1="1" x2="0" y2="29" stroke="black" strokeWidth="1" />
                        <line x1="408" y1="1" x2="408" y2="29" stroke="black" strokeWidth="1" />
                    </svg>
                </div>
                {/* sep haut */}
                <img
                    style={{
                        position: 'absolute',
                        top: '67px',
                        left: '201px',
                        zIndex: 3,
                        width: '313px',
                        height: '27px',
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/sardaigne/sep_1.png"}
                />
                {/* ligne verticale */}
                <div
                    style={{
                        position: 'absolute',
                        top: '175px',
                        left: '514px',
                        width: '10px',
                        height: '240px',
                        zIndex: 3,
                    }}
                >
                    <svg viewBox='0 0 10 300'
                        style={{
                            position: 'absolute',
                            top: 'px',
                            left: '0px',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <line x1="0" y1="0" x2="0" y2="300" stroke="black" strokeWidth="1" />
                    </svg>
                </div>

                {/*current frame */}
                <img
                    style={{
                        position: 'absolute',
                        top: '103px', // changer alignement note ici
                        left: '115px',
                        objectFit: 'cover',
                        objectPosition: 'left',
                        width: '400px',
                        height: '347px',
                        zIndex: 3,
                    }}
                    src={page == 2 ?
                        process.env.PUBLIC_URL + `/assets/images/sardaigne/notes/${frame}.svg` : 'none'}
                />

                {/* 9 triangles */}
                <img
                    style={{
                        position: 'absolute',
                        top: '80px',
                        left: '220px',
                        zIndex: 3,
                    }}
                    src={triangleRef.current[0] == 1 ? process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle_orange.png` : process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle.png`}
                />
                <img
                    style={{
                        position: 'absolute',
                        top: '80px',
                        left: '261px',
                        zIndex: 3,
                    }}
                    src={triangleRef.current[1] == 1 ? process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle_orange.png` : process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle.png`}
                />
                <img
                    style={{
                        position: 'absolute',
                        top: '80px',
                        left: '303px',
                        zIndex: 3,
                    }}
                    src={triangleRef.current[2] == 1 ? process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle_orange.png` : process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle.png`}
                />
                <img
                    style={{
                        position: 'absolute',
                        top: '76px',
                        left: '364px',
                        zIndex: 3,
                    }}
                    src={triangleRef.current[3] == 1 ? process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle_orange.png` : process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle.png`}
                />
                <img
                    style={{
                        position: 'absolute',
                        top: '76px',
                        left: '387px',
                        zIndex: 3,
                    }}
                    src={triangleRef.current[4] == 1 ? process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle_orange.png` : process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle.png`}
                />
                <img
                    style={{
                        position: 'absolute',
                        top: '73px',
                        left: '409px',
                        zIndex: 3,
                    }}
                    src={triangleRef.current[5] == 1 ? process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle_orange.png` : process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle.png`}
                />
                <img
                    style={{
                        position: 'absolute',
                        top: '76px',
                        left: '430px',
                        zIndex: 3,
                    }}
                    src={triangleRef.current[6] == 1 ? process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle_orange.png` : process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle.png`}
                />
                <img
                    style={{
                        position: 'absolute',
                        top: '81px',
                        left: '451px',
                        zIndex: 3,
                    }}
                    src={triangleRef.current[7] == 1 ? process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle_orange.png` : process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle.png`}
                />
                <img
                    style={{
                        position: 'absolute',
                        top: '81px',
                        left: '487px',
                        zIndex: 3,
                    }}
                    src={triangleRef.current[8] == 1 ? process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle_orange.png` : process.env.PUBLIC_URL + `/assets/images/sardaigne/triangle.png`}
                />

                <img
                    style={{
                        position: 'absolute',
                        top: '28px',
                        left: '478px',
                        zIndex: 3,
                        cursor: 'pointer',
                    }}
                    src={boutonOreilleActif ? process.env.PUBLIC_URL + "/assets/images/sardaigne/b_oreille_croix.png" : process.env.PUBLIC_URL + "/assets/images/sardaigne/b_oreille.png"}
                    onClick={changementCanal}
                />

                <div
                    style={{
                        position: 'absolute',
                        top: '464px',
                        left: '101px',
                        width: '380px',
                        height: '23px',
                        zIndex: 3,
                        border: '2px outset black',
                        backgroundColor: '#1c2378',
                    }}
                    className="controls">
                    <img
                        style={{
                            position: 'absolute',
                            top: '-17px',
                            left: '6px',
                            zIndex: 3,
                            cursor: 'pointer',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/play.png"}
                        onClick={playMusic}
                    />
                    <img
                        style={{
                            position: 'absolute',
                            top: '-17px',
                            left: '28px',
                            zIndex: 3,
                            cursor: 'pointer',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/pause.png"}
                        onClick={pauseMusic}
                    />
                </div>

                <p
                    style={{
                        position: 'absolute',
                        top: '447px',
                        left: '494px',
                        zIndex: 3,
                        color: 'lightgrey',
                        fontSize: '18px',
                        fontFamily: 'Times New Roman',
                        cursor: 'pointer',
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.color = 'white';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.color = 'lightgrey';
                    }}
                    onClick={goToPage3}
                >
                    &gt;&nbsp;<span style={{ textDecoration: 'underline' }}>Analyse spectrale</span>
                </p>

                {/* tiroir */}
                <div
                    style={{
                        position: 'absolute',
                        top: '50px',
                        left: `${650 - tailleTirroirRef.current.value}px`,
                        width: `${tailleTirroirRef.current.value}px`,
                        height: '376px',
                        zIndex: 3,
                        backgroundColor: 'white',
                    }}
                    className="tiroir">
                    <img
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '-25px',
                            zIndex: 3,
                            cursor: 'pointer',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/tiroir.png"}
                        onClick={goToPage3}
                    />
                    <img
                        style={{
                            position: 'absolute',
                            top: '15px',
                            left: '7px',
                            objectFit: 'cover',
                            objectPosition: 'left',
                            height: '337px',
                            width: `${tailleTirroirRef.current.value - 14}px`,
                            zIndex: 3,
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/spectre.jpg"}
                    />
                </div>
                <p
                    className='explications_spectre'
                    style={{
                        position: 'absolute',
                        top: '180px',
                        left: '563px',
                        zIndex: 4,
                        color: 'white',
                        fontSize: '12px',
                        textAlign: 'center',
                        opacity: 1,
                    }} >
                    Le spectre <br />
                    indique <br />
                    l'ensemble des <br />
                    harmoniques <br />
                    produits par <br />
                    le choeur.
                </p>
            </div>

            {/* page 3 : spectre */}
            <div
                style={{
                    opacity: page === 3 ? 1 : 0,
                }}
            >
                <div className="background"
                    style={{
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        backgroundColor: '#686eab',
                    }} />
                <img src={process.env.PUBLIC_URL + "/assets/images/sardaigne/note.png"}
                    style={{
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        zIndex: 1,
                        width: '660px'
                    }}
                />

                <div
                    style={{
                        position: 'absolute',
                        top: '464px',
                        left: '101px',
                        width: '540px',
                        height: '23px',
                        zIndex: 3,
                        border: '2px outset black',
                        backgroundColor: '#1c2378',
                    }}
                    className="controls">
                    <img
                        style={{
                            position: 'absolute',
                            top: '-17px',
                            left: '6px',
                            zIndex: 3,
                            cursor: 'pointer',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/play.png"}
                        onClick={() => {
                            if (ex1waiting) {
                                setTimeout(() => {
                                    setShowExplications1(true)
                                }, 6800)
                                setEx1waiting(false)
                            }
                            if (ex2waiting) {
                                setTimeout(() => {
                                    setShowExplications2(true)
                                }, 6800)
                                setEx2waiting(false)
                            }
                            playMusic()
                        }}
                    />
                    <img
                        style={{
                            position: 'absolute',
                            top: '-17px',
                            left: '28px',
                            zIndex: 3,
                            cursor: 'pointer',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/pause.png"}
                        onClick={pauseMusic}
                    />
                    <div
                        style={{
                            position: 'absolute',
                            top: '2px',
                            left: '118px',
                            zIndex: 3,
                            border: '1px inset black',
                            height: '17px',
                            width: '356px',
                        }}
                    >
                    </div>
                </div>

                {/* tiroir qui bouge */}
                <div
                    style={{
                        position: 'absolute',
                        top: '50px',
                        left: `${650 - tailleTirroirRef.current.value}px`,
                        width: `${tailleTirroirRef.current.value}px`,
                        height: '376px',
                        zIndex: 3,
                        backgroundColor: 'white',
                        display: showTirroir ? 'block' : 'none',
                    }}
                    className="tiroir">
                    <img
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '-25px',
                            zIndex: 3,
                            cursor: 'pointer',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/tiroir.png"}
                        onClick={goToPage3}
                    />
                    <img
                        style={{
                            position: 'absolute',
                            top: '15px',
                            left: '7px',
                            objectFit: 'cover',
                            objectPosition: 'left',
                            height: '337px',
                            width: `${tailleTirroirRef.current.value - 14}px`,
                            zIndex: 3,
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/spectre.jpg"}
                    />
                </div>

                {/* grand tiroir */}
                <div
                    style={{
                        position: 'absolute',
                        top: '50px',
                        left: '40px',
                        width: `600px`,
                        height: '376px',
                        zIndex: 3,
                        backgroundColor: 'white',
                        display: showTirroir ? 'none' : 'block',
                    }}
                    className="tiroir">
                    <img
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '-25px',
                            zIndex: 4,
                            cursor: 'pointer',
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/tiroir.png"}
                        onClick={goToPage2From3}
                    />
                    <img
                        style={{
                            position: 'absolute',
                            top: '2px',
                            left: '5px',
                            height: '372px',
                            width: '595px',
                            zIndex: 2,
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/echelle.png"}
                    />
                    <img
                        style={{
                            position: 'absolute',
                            top: '15px',
                            left: '36px',
                            height: '337px',
                            zIndex: 3,
                        }}
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/spectre.jpg"}
                    />
                    <div
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '486px',
                            height: '100px',
                            width: '80px',
                            zIndex: 4,
                            backgroundColor: 'rgba(255, 255, 255, 0.3)',
                            color: 'white',
                            fontSize: '14px',
                            padding: '15px 5px',
                        }}
                    >
                        <p>
                            5 Quintina<br />
                            4 Falzittu<br />
                            3 Bogi<br />
                            2 Contra<br />
                            1 Bassu<br />
                            

                        </p>
                    </div>
                    {/* lignes */}
                    <img
                        style={{
                            position: 'absolute',
                            top: '281px',
                            left: '36px',
                            zIndex: 4,
                            opacity: quintinaSeule ? 0.6 : 1,
                            cursor: quintinaSeule ? 'pointer' : 'default',
                        }}
                        title='Entendre le spectre complet'
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/lignes_spectre_1.png"}
                        onClick={() => {
                            //Changement canal si quintina seule
                            if (boutonOreilleActifRef.current) {
                                changementCanal()
                            }
                            setQuintinaSeule(false)
                        }}
                        onMouseEnter={(e) => {
                            if (quintinaSeule) {
                                setIsHoveredQuitinaSpectre(true)
                                e.target.style.scale = 1.01
                                e.target.style.opacity = 1
                            }
                        }}
                        onMouseLeave={(e) => {
                            setIsHoveredQuitinaSpectre(false)
                            if (quintinaSeule) {
                                e.target.style.scale = 1
                                e.target.style.opacity = 0.6
                            }
                        }}
                    />
                    <p
                        style={{
                            position: 'absolute',
                            top: '282px',
                            left: '279px',
                            zIndex: 4,
                            color: 'black',
                            backgroundColor: "#fce8ac",
                            border: '1px solid black',
                            fontSize: '12px',
                            padding: '0px 5px',
                            display: isHoveredQuitinaSpectre ? 'block' : 'none',
                            pointerEvents: 'none',
                        }}
                    >
                        Entendre le spectre complet
                    </p>
                    <img
                        style={{
                            position: 'absolute',
                            top: '229px',
                            left: '149px',
                            zIndex: 4,
                            transform: isHoveredQuitinaSeule ? 'scale(1.02)' : 'scale(1)',
                            cursor: 'pointer',
                        }}
                        title='Entendre la Quintina seule'
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/ligne_spectre_2.png"}
                        onClick={() => {
                            //Changement canal si quintina seule est false
                            if (!boutonOreilleActifRef.current) {
                                changementCanal()
                            }
                            setQuintinaSeule(true)
                        }}
                        onMouseEnter={(e) => { setIsHoveredQuitinaSeule(true) }}
                        onMouseLeave={(e) => { setIsHoveredQuitinaSeule(false) }}
                    />
                    <p
                        style={{
                            position: 'absolute',
                            top: '202px',
                            left: '379px',
                            zIndex: 4,
                            color: 'black',
                            backgroundColor: "#fce8ac",
                            border: '1px solid black',
                            fontSize: '12px',
                            padding: '0px 5px',
                            display: isHoveredQuitinaSeule ? 'block' : 'none',
                        }}
                    >
                        Entendre la quintina seule
                    </p>
                    <img
                        style={{
                            position: 'absolute',
                            top: '202px',
                            left: '128px',
                            zIndex: 5,
                        }}
                        title='Gommer la Quintina sur un extrait du spectre'
                        src={process.env.PUBLIC_URL + "/assets/images/sardaigne/gomme.png"}
                        onClick={() => { { setShowZoomSpectre(true); gomme1() } }}
                        onMouseEnter={(e) => { setGommeHover(true) }}
                        onMouseLeave={(e) => { setGommeHover(false) }}
                    />
                    <div
                        style={{
                            position: 'absolute',
                            top: '15px',
                            left: '138px',
                            width: '80px',
                            height: '340px',
                            backgroundColor: 'rgba(255, 255, 255, 0.3)',
                            zIndex: 4,
                            display: gommeHover ? 'block' : 'none',
                        }}
                    />

                    {/*curseur*/}
                    <svg
                        style={{
                            position: 'absolute',
                            top: '15px',
                            left: '36px',
                            width: '540px',
                            height: '337px',
                            zIndex: 3,
                        }}
                    >
                        <line
                            x1={cursorPosZoomRef.current}
                            y1='0'
                            x2={cursorPosZoomRef.current}
                            y2='337'
                            strokeWidth='3'
                            stroke='white'
                        />
                    </svg>

                    {/* zoom spectre */}
                    <div
                        className='zoom'
                        style={{
                            position: 'absolute',
                            top: '15px',
                            left: '36px',
                            zIndex: 6,
                            display: showZoomSpectre ? 'block' : 'none',
                        }}
                    >
                        <img
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                height: '337px',
                                zIndex: 6,
                            }}
                            src={process.env.PUBLIC_URL + "/assets/images/sardaigne/spectre.jpg"}
                        />
                        <div
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                height: '337px',
                                width: '540px',
                                zIndex: 6,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            }}
                        />
                        <img
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                zIndex: 7,
                            }}
                            src={process.env.PUBLIC_URL + "/assets/images/sardaigne/zoom.png"}
                        />
                        {/* gomme */}
                        <img
                            className='gomme'
                            style={{
                                position: 'absolute',
                                top: '225px',
                                left: '39px',
                                zIndex: 7,
                            }}
                            src={process.env.PUBLIC_URL + "/assets/images/sardaigne/gomme2.png"}
                        />
                        {/* ligne rouge */}
                        <div
                            className='lignerouge'
                            style={{
                                position: 'absolute',
                                top: '246px',
                                left: '41px',
                                height: '5px',
                                width: '202px',
                                zIndex: 8,
                                backgroundColor: 'red',
                                opacity: 1,
                                borderRadius: '5px',
                            }}
                        />
                        {/* ligne blanche */}
                        <div
                            style={{
                                position: 'absolute',
                                top: '246px',
                                left: '41px',
                                height: '5px',
                                width: '202px',
                                zIndex: 7,
                                backgroundColor: 'white',
                                opacity: 1,
                                borderRadius: '5px',
                            }}
                        />
                        {/* ligne orange1 */}
                        <div
                            className='ligneorange'
                            style={{
                                position: 'absolute',
                                top: '153px',
                                left: '41px',
                                height: '5px',
                                width: '202px',
                                zIndex: 8,
                                backgroundColor: 'orange',
                                opacity: 1,
                                borderRadius: '5px',
                                opacity: 0,
                            }}
                        />
                        {/* ligne blanche1 */}
                        <div
                            className='ligneblanche'
                            style={{
                                position: 'absolute',
                                top: '153px',
                                left: '115px',
                                height: '5px',
                                width: '0px',
                                zIndex: 8,
                                backgroundColor: 'white',
                                opacity: 1,
                                borderRadius: '5px',
                            }}
                        />
                        <img
                            className='gomme2'
                            style={{
                                position: 'absolute',
                                top: '131px',
                                left: '114px',
                                zIndex: 7,
                                opacity: 0,
                            }}
                            src={process.env.PUBLIC_URL + "/assets/images/sardaigne/gomme2.png"}
                        />
                        {/* ligne orange2 */}
                        <div
                            className='ligneorange'
                            style={{
                                position: 'absolute',
                                top: '60px',
                                left: '41px',
                                height: '5px',
                                width: '202px',
                                zIndex: 8,
                                backgroundColor: 'orange',
                                opacity: 1,
                                borderRadius: '5px',
                                opacity: 0,
                            }}
                        />
                        {/* ligne blanche2 */}
                        <div
                            className='ligneblanche'
                            style={{
                                position: 'absolute',
                                top: '60px',
                                left: '115px',
                                height: '5px',
                                width: '0px',
                                zIndex: 8,
                                backgroundColor: 'white',
                                opacity: 1,
                                borderRadius: '5px',
                            }}
                        />
                        <img
                            className='gomme2'
                            style={{
                                position: 'absolute',
                                top: '39px',
                                left: '114px',
                                zIndex: 7,
                                opacity: 0,
                            }}
                            src={process.env.PUBLIC_URL + "/assets/images/sardaigne/gomme2.png"}
                        />
                        {/*curseur*/}
                        <div
                            id='curseur'
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: `${cursorPosRef.current}px`,
                                height: '337px',
                                width: '2px',
                                zIndex: 9,
                                backgroundColor: 'white',
                            }}
                        />

                    </div>

                    {/* explications 1 */}
                    <div
                        style={{
                            position: 'absolute',
                            top: '15px',
                            left: '280px',
                            zIndex: 7,
                            backgroundColor: '#1a1a50',
                            display: showExplications1 ? 'block' : 'none',
                            height: '297px',
                            width: '230px',
                            color: 'white',
                            padding: '20px',
                            fontFamily: 'Times New Roman',
                        }}
                    >
                        <p>
                            Surprise ! Enlever le son que l'on perçoit autour de 400Hz, porté en rouge sur l'écran précédent, ne fait pas disparaître la quintina. <br />
                            Pour qu'on ne l'entende plus, il faut enlever ses harmoniques 2 et 3 (autour de 800 et 1200Hz)
                        </p>
                        <p
                            style={{
                                cursor: 'pointer',
                                color: 'grey',
                                fontFamily: 'Times New Roman',
                            }}
                            onClick={() => { gomme2(); }}
                            //White when hovered
                            onMouseEnter={(e) => { e.target.style.color = 'white'; }}
                            onMouseLeave={(e) => { e.target.style.color = 'grey'; }}
                        >
                            &gt;&nbsp;<span style={{ textDecoration: 'underline' }}>Supprimer les harmoniques 2 et 3 durant un bref instant </span>
                        </p>
                    </div>

                    {/* explications 2 */}
                    <div
                        style={{
                            position: 'absolute',
                            display: showExplications2 ? 'block' : 'none',
                        }}
                    >
                        {/* page 1 */}
                        <div
                            style={{
                                position: 'absolute',
                                top: '15px',
                                left: '280px',
                                zIndex: 7,
                                backgroundColor: '#1a1a50',
                                display: pageExplications == 1 ? 'block' : 'none',
                                height: '297px',
                                width: '230px',
                                color: 'white',
                                padding: '20px',
                                fontFamily: 'Times New Roman',
                            }}
                        >
                            <p>
                                La quintina est une voix fusionnelle, obtenue par la superposition des harmoniques des différentes voix de choeur qui lui confèrent une dynamique particulière.
                                L'expérience précédente prouve qu'elle se comporte comme une fondamentale, ayant son propre spectre harmonique.
                            </p>
                            <p
                                style={{
                                    cursor: 'pointer',
                                    fontFamily: 'Times New Roman',
                                }}
                                onClick={() => { setPageExplications(2) }}
                            >
                                &gt;&nbsp;<span
                                    style={{
                                        color: 'grey',
                                        textDecoration: 'underline',
                                    }}
                                    //White when hovered
                                    onMouseEnter={(e) => { e.target.style.color = 'white'; }}
                                    onMouseLeave={(e) => { e.target.style.color = 'grey'; }}
                                >
                                    Suite
                                </span>
                            </p>
                        </div>

                        {/* page 2 */}
                        <div
                            style={{
                                position: 'absolute',
                                top: '15px',
                                left: '36px',
                                zIndex: 7,
                                backgroundColor: '#1a1a50',
                                display: pageExplications == 2 ? 'block' : 'none',
                                height: '297px',
                                width: '460px',
                                color: 'white',
                                padding: '20px',
                                fontFamily: 'Times New Roman',
                            }}
                        >
                            <p>
                                La quintina : une mélodie de voyelles. <br />
                                <br />
                                Les chanteurs travaillent leurs voix pour en renforcer la dynamique dans une zone moyenne (autour de 1000Hz).<br />
                                A cette fin, ils "colorent" leurs voyelles de façon particulière, évitant par exemple les "i" à cause de leur forte dynamique dans une zone de 2000-2500Hz.<br />
                                <br />
                                Retournons à notre exemple et soyons attentifs aux paroles "Mi-se-re", au début du chant : elles sont prononcées "Mé-sè-ré".<br />
                                <br />
                            </p>
                            <p
                                style={{
                                    cursor: 'pointer',
                                    fontFamily: 'Times New Roman',
                                }}
                                onClick={() => { setPageExplications(3) }}
                            >
                                &gt;&nbsp;
                                <span
                                    style={{ textDecoration: 'underline', color: 'grey' }}
                                    //grey when hovered
                                    onMouseEnter={(e) => { e.target.style.color = 'white'; }}
                                    onMouseLeave={(e) => { e.target.style.color = 'grey'; }}
                                >Suite</span>
                            </p>
                        </div>

                        {/* page 3 */}
                        
                        <div
                            style={{
                                position: 'absolute',
                                top: '15px',
                                left: '36px',
                                zIndex: 7,
                                backgroundColor: '#1a1a50',
                                display: pageExplications == 3 ? 'block' : 'none',
                                height: '297px',
                                width: '460px',
                                color: 'white',
                                padding: '20px',
                                fontFamily: 'Times New Roman',
                            }}
                        >
                            <p>
                                Cette altération vocalique systématique est facilitée par le fait que le texte est en latin, une langue étrangère aux chanteurs. Ils n'hésitent pas à dilater les voyelles, à les transformer et les allonger à des fins strictement musicales. <br />
                                <br/>
                                Les consonnes, quant à elles, occupent peu de place dans le chant. Lorsqu'elles surviennent, elles créent une rupture dans le spectre et stoppent inévitablement l'émergence de la quintina. <br />
                                <br />
                                Cette micro-grammaire, â la fois phonétique et acoustique, est bien connue des meilleurs chanteurs : ces derniers portent leur attention sur leurs propres hauteurs d'intonation et tout autant sur la couleur de leur spectre se combinant avec celui des autres voix.
                            </p>
                            <p
                                style={{
                                    cursor: 'pointer',
                                    fontFamily: 'Times New Roman',
                                }}
                                onClick={reset}
                            >
                                &gt;&nbsp;
                                <span
                                    //grey when hovered
                                    onMouseEnter={(e) => { e.target.style.color = 'white'; }}
                                    onMouseLeave={(e) => { e.target.style.color = 'grey'; }}
                                    style={{ textDecoration: 'underline' }}>
                                    Retour au spectre
                                </span>
                            </p>
                                <div
                                style={{
                                    position: 'absolute',
                                    left: '300px',
                                    top: '275px',
                                    fontFamily: 'Times New Roman',
                                    color: 'white',
                                }}
                                >
                                    <p>
                                        &gt;&nbsp;
                                    <span
                                        //grey when hovered
                                        onMouseEnter={(e) => { e.target.style.color = 'white'; }}
                                        onMouseLeave={(e) => { e.target.style.color = 'grey'; }}
                                        onClick={() => window.parent.location.href = 'https://digitaljazz.fr/clesdecoute' +'/sardaigne/mesere/'
                                            //navigate(process.env.PUBLIC_URL + '/sardaigne/mesere/')
                                            }
                                        style={{ textDecoration: 'underline' }}>
                                        Méséré
                                    </span>
                                    </p>
                                
                            </div>

                        </div>
                        
                    </div>
                </div>
            </div >
        </>

    );
}

export default Sardaigne;
